var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTopLeftCorner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 261,
    viewBox: "0 0 117 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 258.805V258.805C54.8536 244.458 11.2289 189.515 11.2289 126.221V12.8052",
    stroke: "#4285F4",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6968 0.305176L1.56705 18.0135H21.8265L11.6968 0.305176Z",
    fill: "#4285F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTopLeftCorner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/top_left_corner.3285e57ad768777f0a47b1c2096db36e.svg";